<template>
  <div v-if="vantaggi" class="vantaggi">
    <common-hero v-if="vantaggi.imageDesk" :background="{desktop: vantaggi.imageDesk.responsiveImage.src, mobile: vantaggi.imageMobile && vantaggi.imageMobile.responsiveImage ? vantaggi.imageMobile.responsiveImage.src : vantaggi.imageDesk.responsiveImage.src }" :tag="'div'">
      <span class="common-hero__processing-order common-hero-label text-to-uppercase">{{ vantaggi.intro }}</span>
      <div v-html="vantaggi.title"/>
      <div v-html="vantaggi.subtitle" />
    </common-hero>
    <section class="padding-paragrafo">
      <accordion v-if="vantaggi.accordion && vantaggi.accordion.length ">
        <accordion-item
          v-for="(detail, index) of vantaggi.accordion"
          :key="index">
          <template slot="accordion-trigger">
            <h4 v-html="detail.title"/>
          </template>
          <template slot="accordion-content">
            <div v-html="detail.content" />
          </template>
        </accordion-item>
      </accordion>
      <div class="brochure-container">
        <div class="default-container">
          <p class="brochure__title" v-html="$t('moreInfo')" />
          <Brochure
            :to="{ name: `${lang}-richiesta-brochure`, params: { lang } }"
            :label="$t('brochureTecnica')"
            class="def-brochure"
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import _ from 'lodash'
import lang from '@/views/mixins/lang'
import dataLoad from '@/views/mixins/dataLoad'
import CommonHero from '@/components/CommonHero'
import InnerMenu from '@/components/InnerMenu'
import Accordion from '@/components/Accordion'
import AccordionItem from '@/components/AccordionItem'
import Brochure from '@/components/Brochure'
import { vantaggiPage } from '@/queries/vantaggi.js'

export default {
  mixins: [ lang, dataLoad ],
  name: 'home',
  components: {
    CommonHero,
    InnerMenu,
    Accordion,
    AccordionItem,
    Brochure
  },
  data: () => ({
    vantaggi: {},
    seo: {}
  }),
  apollo: {
    vantaggi: {
      query: vantaggiPage,
      fetchPolicy: 'cache-and-network',
      prefetch: true,
      variables () {
        return {
          locale: this.$i18n.locale
        }
      },
      result (result) {
        if (result.data) {
          this.vantaggi = result.data.vantaggi
          this.seo = this.vantaggi.seo
        }
      }
    }
  },
  props: {
    hash: {
      type: String,
      required: false
    }
  },
  computed: {
    imgServer: {
      get () {
        return process.env.VUE_APP_ENDPOINT
      }
    },
    innerMenuList: {
      get () {
        return _.map(this.pageApiData.sections, ({ slug, title }) => ({
          hash: `#${slug}`,
          title
        }))
      }
    },
    textLink: {
      get () {
        if (window.matchMedia('(max-width: 700px)').matches) return this.pageApiData.sectorscta_cta_small
        return this.pageApiData.sectorscta_cta
      }
    }
  },
  directives: {
    'update-route': {
      bind (el, binding) {
        const threshold = 0.25
        const observer = new window.IntersectionObserver(entries => {
          _.forEach(entries, entry => {
            if (entry.isIntersecting && entry.intersectionRatio >= threshold) binding.value()
          })
        }, { threshold })

        observer.observe(el)
      }
    }
  }
}
</script>

<style lang="scss">
@import "../assets/mixins/breakpoints";
@import "../assets/mixins/typo";
@import "../assets/mixins/common";

.listing-settori{
  background-color:#FFF;
  top: -85px;
  article{
    display: flex;
    position: relative;
    flex-wrap: wrap;
    @media #{$large_mq} {
      flex-wrap: nowrap
    }
  }
  article:nth-child(odd){
    @media #{$large_mq} {
      flex-direction: row-reverse;
    }
    .settori_section{
      margin-left: 0;
    }
  }

  picture{
    width: 100%;
    @media #{$large_mq} {
      width: 50%;
    }
    img{
        width: 100%; height: auto;
        display: block;
      }
  }

  .listing-settori--absolute-area{
    margin: 4rem 0 8rem;
    @media #{$large_mq} {
      margin: 0;
      position: absolute; width: 100%;
      left: 0; top: 0; height: 100%;
      .default-container, .settori_section{
        height: 100%;
      }
    }
  }

  .settori_section{
    @media #{$large_mq} {
      width: 40%;
      margin-left: 60%;
      .settori_section__content{
        top: 50%;
        transform: translate3d(0, -50%, 0);
      }
    }
  }

  .settori_section__content{
    h3{
      margin-bottom: 1.5rem;
      margin-top: 0;
    }
    h2{
      @include hero-title(#4A4A4A);
      margin-top: 0;
      br{
        display: none;
        @media #{$large_mq} {
          display: none;
        }
      }
    }
    p{
      line-height: 1.8;
      margin-bottom: 0;
    }
  }
}

.accordion__item:nth-child(even){
  background-color: #FFF;
}

.accordion__trigger h4{
  font-size: 1.3rem;
  line-height: 1.3;
  font-family: 'IBM Plex Sans Condensed', sans-serif;
  font-weight: 300;
  color: #343434;
  width: 90%;
  @media #{$medium_mq} {
    font-size: 1.65rem;
  }
  @media #{$large_mq} {
    font-size: 2rem;
    width: 80%;
  }
  @media #{$xlarge_mq} {
    font-size: 2.5rem;
    width: 70%;
  }
  @media #{$xxlarge_mq} {
    font-size: 2.8125rem;
  }
}

.accordion__content {
  width: 90%;
  @media #{$large_mq} {
    width: 80%;
  }
  @media #{$xlarge_mq} {
    width: 70%;
  }
  p{
    font-size: 1rem;
    line-height: 1.4;
    color: #343434;
    font-family: 'IBM Plex Mono', sans-serif;
    font-weight: 400;
    display: block;
    padding-bottom: 40px;
    @media #{$medium_mq} {
      font-size: 1.15rem;
      padding-bottom: 50px;
    }
    @media #{$large_mq} {
      font-size: 1.25rem;
      padding-bottom: 60px;
    }
    @media #{$xlarge_mq} {
      font-size: 1.35rem;
      padding-bottom: 70px;
    }
    @media #{$xxlarge_mq} {
      font-size: 1.5rem;
      padding-bottom: 80px;
    }
  }
}
.brochure-container{
  padding-top: 120px;
  @media #{$medium_mq} {
    padding-top: 140px;
  }
  @media #{$large_mq} {
    padding-top: 160px;
  }
  @media #{$xlarge_mq} {
    padding-top: 200px;
  }
  @media #{$xxlarge_mq} {
    padding-top: 260px;
  }
  .brochure__title{
    font-size: .9rem;
    color: #343434;
    font-family: 'IBM Plex Mono', sans-serif;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: .05rem;
    margin-bottom: 27px;
    @media #{$large_mq} {
        font-size: 1.05rem;
    }
    @media #{$xlarge_mq} {
        font-size: 1.125rem;
    }
  }
}

.def-brochure.brochure {
  display: inline-block;
@media #{$large_mq_max} {
        margin-top: 0px;
    }
}

</style>
